import axios from "axios";
import { PermClientError } from "../Libs/Utils/exceptions";
import { API_PORT, API_URL } from "../config";
import curlirize from 'axios-curlirize';

const API_URL_PORT = `${API_URL}`
const axiosInstance = axios.create({
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
  timeout: 40000,
  validateStatus: (status) => status < 400,
});

curlirize(axiosInstance, (result, err) => {
  const {command} = result;
  if (err) {
    console.log('err cc', err);
  } else {
    console.log(command);
  }
});

const axiosCall = async (axiosInst, url, { query, ...requestOptions }) =>
  axiosInst({
    method: requestOptions.method,
    url: encodeQueryParams(`${API_URL_PORT}${url}`, query).toString(),
    data: requestOptions.body,
    headers: requestOptions.headers,
  });

const apiCall = async (...args) => {
  try {
    const response = await axiosCall(axiosInstance, ...args);
    if (response.status >= 200 && response.status < 400) {
      return response;
    }
    return null;
  } catch (error) {
    if (error.response && error.response.status === 401) {
      throw new PermClientError();
    } else {
      if (error.response) {
        if (error.response.data) {
          if (error.response.data.message) {
            throw new Error(error.response.data.message);
          }
          if (error.response.data.errors) {
            throw new Error(
              error.response.data.errors
                .map((e) => `${e.param}: ${e.msg}`)
                .join(". ")
            );
          }
          throw new Error("Uh-oh, something went wrong.😥");
        } else {
          throw new Error("Uh-oh, something went wrong.😥");
        }
      } else {
        console.log(error);
        throw new Error("Uh-oh, are you connected to the internet?😥");
      }
    }
  }
};

const encodeQueryParams = (url, query) => {
  const encodeURL = new URL(url);
  if (query) {
    Object.entries(query).forEach(([k, v]) =>
      encodeURL.searchParams.append(k, v)
    );
  }
  return encodeURL;
};

export const manualAuthAxiosCall = async (token, url, requestOptions) => {
  return apiCall(url, {
    ...requestOptions,
    headers: {
      ...requestOptions.headers,
      Authorization: `Bearer ${token}`,
    },
  });
};
